import { Sparkle } from "./Mark";
import { MARQUEE } from "../../content";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {MARQUEE.map((t) => (
      <span key={t} className="flex items-center">
        <span className="px-8 sm:px-12 font-display italic font-light text-3xl sm:text-5xl text-[#FAF6ED]/80 whitespace-nowrap">{t}</span>
        <Sparkle className="w-3.5 h-3.5 text-[#B59A5B]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" aria-label="Areas of consultation" className="relative py-10 sm:py-14 border-y border-[#B59A5B]/20 overflow-hidden bg-[#0F161E]">
    <div className="flex w-max marquee-track">
      <Row />
      <Row hidden />
    </div>
  </section>
);
